import { getIsNav4TenantOptIn } from '@atlassian/jira-navigation-apps-sidebar-nav4-get-user-meta/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { getWillShowNav4TenantOptIn } from '../get-will-show-nav4-tenant-opt-in/index.tsx';
import { getWillShowNav3 } from '../get-will-show-nav3.tsx';

export function getIsPhase1AdminStandardCohort() {
	return (
		getWillShowNav4TenantOptIn() && // This FG is only true for Admins
		(!getIsNav4TenantOptIn() || getWillShowNav3()) &&
		fg('jira_nav4_ga_phase-2-standard') // To be implemented
	);
}
